import { IntegrationKind } from "@redotech/redo-integrations-core";
import * as z from "zod";
import { IntegrationSchema } from "../types";

export const getAvailableIntegrations = {
  name: "getAvailableIntegrations" as const,
  // If integrationKinds is provided, only return integrations of the specified kinds
  // If integrationKinds is not provided, return all integrations
  input: z.object({
    integrationKinds: z.array(z.enum(IntegrationKind)).optional(),
    customDescriptions: z.record(z.string(), z.string()).optional(),
  }),
  output: z.object({ integrations: z.record(z.string(), IntegrationSchema) }),
};
